module.exports = __webpack_public_path__ + "img/1.f41a14f9.png";